import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  ContainerButton,
  Button,
  ButtonCancel,
  Title,
  Text,
  Image,
} from './styles';

const ScreenShareInstructions = (props) => {
  const { history, STEPS, setCurrentStep } = props;
  const handleCancel = () => {
    history.goBack();
  };

  const handleNextStep = () => {
    setCurrentStep(STEPS.SCREEN_SHARE);
  };

  return (
    <Container>
      <Title>Screen share check</Title>
      <Text>On the next step, please do the following:</Text>

      <Text>1. Click &quot;Entire screen&quot;</Text>
      <Image src="/images/screen-share-instructions-1.png" alt="instructions-step-1" />

      <Text>2. If you have multiple screens/monitors, make sure to select this monitor</Text>
      <Image src="/images/screen-share-instructions-2.png" alt="instructions-step-2" />

      <Text>3. Click &quot;Share&quot;</Text>
      <Image src="/images/screen-share-instructions-3.png" alt="instructions-step-3" />

      <Text>4. Continue to the next screen</Text>

      <ContainerButton>
        <ButtonCancel onClick={handleCancel}>
          Cancel
        </ButtonCancel>
        <Button onClick={handleNextStep}>
          Continue
        </Button>
      </ContainerButton>
    </Container>
  );
};

ScreenShareInstructions.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  STEPS: PropTypes.shape({
    SCREEN_SHARE: PropTypes.string,
  }).isRequired,
};

export default ScreenShareInstructions;
